import { Order, User } from '@protos/v2/order';
import { OrderFilterConfig } from './OrderFieldFilter';
import { snakeToTitleCase } from '@utils/string';

const getUniqueValues = <T>(arr: T[], getValue: (item: T) => string): string[] => {
  const uniqueValues = new Set<string>();
  arr.forEach(item => {
    uniqueValues.add(getValue(item));
  });
  return Array.from(uniqueValues);
};

const getValueCounts = <T>(arr: T[], getValue: (item: T) => string): Record<string, number> => {
  const counts: Record<string, number> = {};
  arr.forEach(item => {
    const value = getValue(item);
    counts[value] = (counts[value] || 0) + 1;
  });
  return counts;
};

export const createFilterConfig = (orders: Order[], field: keyof Order | keyof User, isUserField: boolean, label: string): OrderFilterConfig => {
  const uniqueValues = getUniqueValues(orders, order => (isUserField ? order.user[field] : order[field]));
  const counts = getValueCounts(orders, order => (isUserField ? order.user[field] : order[field]));
  const valuesWithCounts = uniqueValues.filter(value => counts[value] > 0);

  return {
    field,
    label: label,
    options: valuesWithCounts.map(value => ({
      value,
      label: snakeToTitleCase(value.toString()),
      count: counts[value],
    })),
    getValue: (order: Order) => (isUserField ? order.user[field].toString() : order[field].toString()),
  };
};
